import classNames from "classnames";
var classes = {
    base: 'gap-1 flex flex-col pl-3 dark:text-white',
    type: {
        bullet: 'list-disc list-inside',
        number: 'list-decimal',
    }
};
var List = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'bullet' : _b, className = _a.className;
    var ListTag = type == 'bullet' ? 'ul' : 'ol';
    return <ListTag className={classNames(classes.base, classes.type[type], className)}>{children}</ListTag>;
};
export default List;
